import type { SessionMessageWithParts } from "schemas/generated/opencode";

import React from "react";

import { Button } from "@replo/design-system/components/button/Button";
import {
  Menu,
  MenuContent,
  MenuItem,
  MenuTrigger,
} from "@replo/design-system/components/menu/Menu";
import { Tooltip } from "@replo/design-system/components/tooltip/Tooltip";
import shouldShowV2Debuggers from "@v2/utils/shouldShowV2Debuggers";
import { ExternalLink, MoreHorizontal } from "lucide-react";

export function DebugMenuAction({
  message,
}: {
  message: SessionMessageWithParts;
}) {
  const isDebug = shouldShowV2Debuggers();

  if (!isDebug) {
    return null;
  }

  const messageAdminUrl = `https://admin.replo.app/dashboard/chat-messages?chatMessageId=${message.message.id}`;

  return (
    <Menu>
      <Tooltip content="More options" triggerAsChild>
        <MenuTrigger
          render={
            <Button icon size="sm" variant="tertiary">
              <MoreHorizontal />
            </Button>
          }
        />
      </Tooltip>
      <MenuContent align="end">
        <MenuItem
          label="View Message In Admin"
          startEnhancer={<ExternalLink />}
          onClick={() => {
            window.open(messageAdminUrl, "_blank");
          }}
        />
      </MenuContent>
    </Menu>
  );
}
